import { Button } from "react-bootstrap";
import { DateHelper } from "../../../../../helper";
import { RequestType, requestStatus, requestTypeDetail, requestTypes } from "../../../../../constants";
import { ApprovalStatus, FontFa } from "../../../../../components";
import { ColumnsType } from "antd/lib/table";
import { downloadExcel } from "react-export-table-to-excel";
import { TableHelpers } from "../../../../../helper/TableHelper";

const exportHeader = [
  "STT",
  "Đơn vị",
  "Sân bay trực thuộc",
  "Bộ phận trung tâm",
  "Cấp mới tài khoản hệ thống",
  "Nhóm User",
  "Chức danh",
  "Họ và tên",
  "Mã nhân viên",
  "Email",
  "SĐT", //
  "CMND/CCCD",
  "Đề nghị",
  "Chi tiết đề nghị",
  // "User ID",
];

const exportChangeHeader = [
  "STT",
  "Sân bay trực thuộc",
  "Bộ phận",
  "Nhóm User",
  "Chức danh",
  "Duty Code",
  "Office",
  "Họ và tên",
  "Mã nhân viên",
  "User ID",
  "Email",
  "SĐT",
  "CMND/CCCD",
  "Hệ thống",
  "Nội dung thay đổi",
  "Chi tiết đề nghị",
];

const handleMapProvide = (data: any[]) =>
  data.map((e: any, number) => ({
    STT: number + 1,
    Unit: "VIAGS",
    CodePcc: e.CodePcc,
    WorkingDepartment: e.WorkingDepartment,
    System: e.System,
    FunctionCode: e.FunctionCode,
    Title: e.Title,
    Users: e.Users,
    EmployeeCode: e.EmployeeCode,
    Email: e.Email,
    PhoneNumber: e.PhoneNumber,
    IdUser: e.IdUser,
    Request: e.Request,
    DetailedDescriptionOfTheRequest: e.DetailedDescriptionOfTheRequest,
  }));

const handleMapChange = (data: any[]) =>
  data.map((e: any, number) => ({
    STT: number + 1,
    CodePcc: e.CodePcc,
    WorkingDepartment: e.WorkingDepartment,
    FunctionCode: e.FunctionCode,
    Title: e.Title,
    DutyCode: e.DutyCode,
    Office: e.Office,
    Users: e.Users,
    EmployeeCode: e.EmployeeCode,
    CaseHasBeenGranted: e.CaseHasBeenGranted,
    Email: e.Email,
    PhoneNumber: e.PhoneNumber,
    IdUser: e.IdUser,
    System: e.System,
    Request: e.Request,
    DetailedDescriptionOfTheRequest: e.DetailedDescriptionOfTheRequest,
  }));

export const useEprCodeColumns = () => {
  const columns: ColumnsType<any> = [
    {
      title: "Mã YC",
      dataIndex: "id",
      key: "id",
      align: "center" as const,
      width: "100px",
      ...TableHelpers.searchInput({ dataIndex: "id" }),
    },
    {
      title: "Ngày tạo",
      dataIndex: "createdDateTime",
      key: "createdDateTime",
      render: (text: string) => DateHelper.formatDateToString(text),
      align: "center" as const,
      width: "150px",
      ...TableHelpers.searchRangePicker({ dataIndex: "createdDateTime" }),
    },
    {
      title: "Người tạo",
      dataIndex: "createdByName",
      key: "createdByName",
      width: "200px",
      ...TableHelpers.searchInput({ dataIndex: "createdByName" }),
      //   render: (text: string) =>
      //     StringHelper.verticalBarSplit<string[]>(text)[1],
    },
    {
      title: "Yêu cầu",
      dataIndex: "eRequestType",
      key: "eRequestType",
      render: (text: string) => (
        <div className={`flag ${requestTypeDetail[text as RequestType].flag}`}>{requestTypes[text]}</div>
      ),
      width: "100px",
      filters: [
        {
          text: "Thay đổi",
          value: "change",
        },
        {
          text: "Cấp mới",
          value: "provide",
        },
      ],
      onFilter: (status: any, record) => status.includes(record.eRequestType),
    },
    {
      title: "Mô tả",
      dataIndex: "eDescription",
      key: "eDescription",
      onCell: () => {
        return {
          style: {
            whiteSpace: "normal",
            wordWrap: "break-word",
            maxWidth: "400px", // optional max width to constrain very long content
          },
        };
      },
      ...TableHelpers.searchInput({ dataIndex: "eDescription" }),
    },
    {
      title: "Trạng thái",
      dataIndex: "eRequestStatus",
      key: "eRequestStatus",
      render: (text: string) => <ApprovalStatus status={text} />,
      filters: [
        {
          text: "Đang đợi duyệt",
          value: requestStatus.submitted,
        },
        {
          text: "Đang thực hiện",
          value: requestStatus.inProgress,
        },
        {
          text: "Đã hoàn tất",
          value: requestStatus.completed,
        },
        {
          text: "Đã bị từ chối",
          value: requestStatus.rejected,
        },
      ],
      onFilter: (status: any, record) => record.eRequestStatus.indexOf(status) === 0,
    },
    {
      title: "Xuất tài liệu",
      dataIndex: "export",
      key: "export",
      align: "center" as const,
      width: 120,
      render: (_: string, record: any) => (
        <Button
          title="Xuất file"
          variant="outline-danger"
          onClick={(e: any) => {
            e.stopPropagation();
            const body = JSON.parse(record.eContent);
            const mappedBody = record.eRequestType === "provide" ? handleMapProvide(body) : handleMapChange(body);
            downloadExcel({
              fileName: "DS_CapCodeAmadeus_" + record.id,
              sheet: "Sheet1",
              tablePayload: {
                header: record.eRequestType === "provide" ? exportHeader : exportChangeHeader,
                body: mappedBody,
              },
            });
          }}
        >
          <FontFa name="faPrint" size={"xs"} />
        </Button>
      ),
    },
  ];
  return { columns };
};
